import { render, staticRenderFns } from "./EditorialProjects.vue?vue&type=template&id=a5ac28e4&scoped=true&"
import script from "./EditorialProjects.vue?vue&type=script&lang=ts&"
export * from "./EditorialProjects.vue?vue&type=script&lang=ts&"
import style0 from "./EditorialProjects.vue?vue&type=style&index=0&id=a5ac28e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ac28e4",
  null
  
)

export default component.exports